import { Layout, Menu } from "antd";
import { FC, useState, useEffect } from "react";
import styles from "./index.module.scss";
import "./index.scss";
import { SidebarProps } from "./types";
import { useSelector } from "react-redux";

// Global sidebar
const Sidebar: FC<SidebarProps> = (props) => {
  // Initialize variables and state
  const { Sider } = Layout;
  const { handleSidebar, items, selectedSidebar } = props;
  const [openKeys, setOpenKeys] = useState<string[]>([]);

  const profileData = useSelector((state: any) => state?.userProfile?.data);

  // Auto-expand warehouse sub-menu when a sub-item is selected
  // Auto-collapse warehouse sub-menu when a different main menu item is selected
  useEffect(() => {
    if (["sales-order", "shipping", "packing-list"].includes(selectedSidebar)) {
      // If a warehouse sub-item is selected, expand the warehouse sub-menu
      setOpenKeys(["warehouse"]);
    } else if (
      ["", "sales", "inventory-control", "email-config"].includes(
        selectedSidebar
      )
    ) {
      // If a main menu item is selected, collapse the warehouse sub-menu
      setOpenKeys([]);
    }
  }, [selectedSidebar]);

  // filter above item based on profileData role
  // const filteredItems = items?.filter((item: any) => {
  //   if (
  //     profileData?.companyRoles[0]?.role?.roleName === "Service Center Employee"
  //   ) {
  //     return item.label !== "Item Inventory";
  //   } else if (profileData?.companyRoles[0]?.role?.roleName === "Employee") {
  //     return item.label;
  //   }
  //   return true;
  // });

  const filteredItems = items?.filter((item: any) => {
    if (profileData?.companyRoles[0]?.role?.roleName === "3nStar Employee 1") {
      return item.label;
    }
    return true;
  });

  // JSX
  return (
    <Sider
      style={{
        background: "#fff",
        maxHeight: "100%",
        height: "100%",
        overflow: "auto",
      }}
      className={styles.sidebar}
    >
      <div className={styles.sidebar__wrapper}>
        <Menu
          mode="inline"
          defaultSelectedKeys={[selectedSidebar]}
          selectedKeys={[selectedSidebar]}
          openKeys={openKeys}
          onOpenChange={setOpenKeys}
          items={filteredItems}
          onClick={(info) => {
            console.log("Menu clicked:", info);
            handleSidebar(info);
          }}
          className="menu-item "
          style={{
            background: "#fff",
            padding: 0,
          }}
        />
      </div>
    </Sider>
  );
};

export default Sidebar;
